import { computed, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { InterpolationParameters } from '@ngx-translate/core/lib/translate.service';
import { map } from 'rxjs';

export const useI18n = () => {
    const translate = inject(TranslateService);
    const language = toSignal(translate.onLangChange
        .pipe(
            takeUntilDestroyed(),
            map((v) => v.lang)
        ), {
        initialValue: translate.currentLang
    });
    const translations = toSignal(translate.onTranslationChange
        .pipe(
            takeUntilDestroyed(),
            map((v) => v.translations)
        ), {
        initialValue: translate.translations
    });

    const t = (key: string | string[], interpolateParams?: InterpolationParameters) => translate.instant(key, interpolateParams);

    return computed(() => ({
        language: language(),
        translations: { ...translations() },
        t
    }));
};

